import React from "react";
import Header from "./Header/Index";
import Footer from "./Footer/Index";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar/Index";

function Index() {
  return (
    <>
      <div className="d-flex" id="wrapper">
        {/* sidebar */}
        <Sidebar />
        <div id="page-content-wrapper">
          <Header />
          <main className="px-3">
            <Outlet /><br /><br /><br /><br /><br />
          </main>
          <Footer />
        </div>
      </div>
    </>
  );
}

export default Index;
